import { TrackJS } from "trackjs-nextjs"

import { SANDBOX, TRACKJS_TOKEN } from "./config"
import { QUOTE_ID_KEY } from "./storage"

if (!SANDBOX && typeof window !== "undefined" && !TrackJS.isInstalled()) {
  TrackJS.install({
    token: TRACKJS_TOKEN,
    application: "france",
    onError: (payload) => {
      const message = payload.message || ""
      const ignoredPatterns = [
        "event-track.dalma",
        "analytics.google.com",
        "google-analytics.com",
        "amplitude.com",
        "Amplitude Logger",
        "_AutofillCallbackHandler",
      ]
      return !ignoredPatterns.some((pattern) => message.includes(pattern))
    },
    // for more configuration options, see https://docs.trackjs.com
  })
}

export function addQuoteIdToTrackJS(quoteId: string | undefined) {
  try {
    TrackJS?.addMetadata(QUOTE_ID_KEY, quoteId || "no quote id")
  } catch {}
}
